import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';

import { TABLE_COL_WIDTH, TABLE_FIRST_COL_WIDTH } from '../../constants/table';
import { RESIZE_THROTTLE_DELAY } from '../../constants/delays';

export const useLast = (count: number): [number, React.RefObject<HTMLDivElement | null>] => {
  const [last, setLast] = React.useState(0);
  const headRowRef = React.useRef<HTMLDivElement>(null);

  const checkLast = React.useCallback(() => {
    if (headRowRef.current) {
      const { left } = headRowRef.current.getBoundingClientRect();

      const { innerWidth } = window;
      const visibleCol = Math.floor((innerWidth - left - TABLE_FIRST_COL_WIDTH) / TABLE_COL_WIDTH);
      const lastVisible = count - visibleCol;
      setLast(lastVisible > 0 ? lastVisible : 0);
    }
  }, [count]);

  useIsomorphicLayoutEffect(() => {
    checkLast();
    const handleResize = throttle(RESIZE_THROTTLE_DELAY, checkLast);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [checkLast]);

  return [last, headRowRef];
};
